import React, { useState, useEffect, useMemo } from "react";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import classnames from "classnames";
import { numberWithCommas } from "lib/general-helper";

const PerformanceRow = (props) => {
  const { userData, username, currentStat, progress } = props;
  const progressBarValue = progress[username];
  const { getChampionImg } = getRiotAssetsContext();
  const result = userData["className"];
  const selectedResult = `selected-${result}`;
  const progressResult = `progress-${result}`;
  const kda = userData["KDA"] === "Perfect" ? "Perfect" : parseFloat(userData["KDA"]).toFixed(2);
  return (
    <div className={`performance-row ${result}`}>
      <div className="image-container">
        <img src={getChampionImg(userData["championId"])} className="champion-img"></img>
      </div>
      <div className="summoner-level">{userData.level}</div>
      <div className="player-container">
        <div className="username">{username}</div>
        <div className={`progress-bar ${result}`}>
          <div className={progressResult} style={{ width: `${progressBarValue}%` }}></div>
        </div>
      </div>
      <div className={classnames("kills", currentStat === "Kills" ? selectedResult : "")}>{userData["Kills"]}</div>
      <div className={classnames("kda", currentStat === "KDA" ? selectedResult : "")}>{kda}</div>
      <div className={classnames("damage", currentStat === "Damage" ? selectedResult : "")}>
        {numberWithCommas(userData["Damage"])}
      </div>
      <div className={classnames("gold", currentStat === "Gold" ? selectedResult : "")}>{numberWithCommas(userData["Gold"])}</div>
      <div className={classnames("wards", currentStat === "Wards" ? selectedResult : "")}>{userData["Wards"]}</div>
      <div className={classnames("cs", currentStat === "CS" ? selectedResult : "")}>{userData["CS"]}</div>
    </div>
  );
};

const SelectButton = (props) => {
  const { title, setCurrentStat, currentStat } = props;
  const selected = title === currentStat ? "selected" : "";
  const containerSelected = title === currentStat ? "tab-container-selected" : "";
  return (
    <div className={`tab ${containerSelected}`}>
      {title === "Player" ? (
        title
      ) : (
        <>
          <div
            className={`tab-title ${selected}`}
            onClick={() => {
              setCurrentStat(title);
            }}
          >
            {title}
          </div>
        </>
      )}
    </div>
  );
};

const Performance = (props) => {
  const { data } = props;
  // console.log(data);
  const postGameData = data["match"]["historicalData"]["postGameData"];
  const winningTeam = data["match"]["winningTeam"];
  const [currentStat, setCurrentStat] = useState("Damage");
  const [displayRows, setDisplayRows] = useState({});
  const [staticInfo, setStaticInfo] = useState({});
  const [progress, setProgress] = useState({});
  const tabs = ["Player", "Kills", "KDA", "Damage", "Gold", "Wards", "CS"];

  const getPlayerStats = (postGameData, winningTeam) => {
    let userStats = {};
    for (const player of postGameData) {
      userStats[player["summonerName"]] = {
        level: player["level"],
        championId: player["championId"],
        className: player["teamId"] === winningTeam ? "win" : "loss",
        Damage: player["damage"],
        Kills: player["kills"],
        KDA: player["deaths"] === 0 ? "Perfect" : (player["kills"] + player["assists"]) / player["deaths"],
        Gold: player["gold"],
        Wards: player["wardsPlaced"],
        CS: player["cs"] + player["jungleCs"],
      };
    }
    return userStats;
  };

  const sortRows = (sortBy) => {
    let progressStats = {};
    const allPlayerPairs = Object.keys(staticInfo).map((key) => [key, staticInfo[key]]);
    const sortedRows = Object.fromEntries(allPlayerPairs.sort((a, b) => b[1][sortBy] - a[1][sortBy]));
    if (Object.keys(sortedRows).length !== 0) {
      const baseValue = sortedRows[Object.keys(sortedRows)[0]][sortBy];
      for (const [key, value] of Object.entries(sortedRows)) {
        progressStats[key] = (parseFloat(sortedRows[key][sortBy]) / baseValue) * 100;
      }
    }
    setProgress(progressStats);
    return sortedRows;
  };

  useEffect(() => {
    setStaticInfo(getPlayerStats(postGameData, winningTeam));
  }, []);

  useEffect(() => {
    setDisplayRows(sortRows(currentStat));
  }, [currentStat, staticInfo]);

  return (
    <div className="mobile-static">
      <div className="mobile-slide">
        <div className="expanded-performance-container">
          <div className="description-header">
            {tabs.map((tab) => (
              <SelectButton title={tab} setCurrentStat={setCurrentStat} currentStat={currentStat} key={tab} />
            ))}
          </div>
          <div className="performance-rows">
            {Object.keys(displayRows).map((username) => (
              <PerformanceRow
                userData={displayRows[username]}
                username={username}
                key={username}
                currentStat={currentStat}
                progress={progress}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Performance;
